import styles from './MobileNavigation.module.scss';
import Overlay from '@components/components/Navigation/components/MobileNavigation/components/Overlay/Overlay';
import MobileMenu from '@components/components/Navigation/components/MobileNavigation/components/MobileMenu/MobileMenu';
import React, { useState } from 'react';
import classNames from 'classnames';

const MobileNavigation = ({
  items,
  isReduced,
  metaMenu,
  rootLevel,
  logoLink,
  logoLinkDescription,
  logoType,
}) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  return (
    <>
      <nav
        aria-hidden={showOverlay}
        aria-label="Menüleiste"
        className={classNames(styles.container, {
          [styles.isSearchOpen]: isSearchOpen,
          [styles.showOverlay]: showOverlay,
        })}
      >
        <MobileMenu
          isReduced={isReduced}
          isSearchOpen={isSearchOpen}
          logoLink={logoLink}
          logoLinkDescription={logoLinkDescription}
          logoType={logoType}
          serviceUrl={rootLevel?.service}
          setIsSearchOpen={setIsSearchOpen}
          setShowOverlay={setShowOverlay}
          showOverlay={showOverlay}
        />
      </nav>
      <Overlay
        isReduced={isReduced}
        isSearchOpen={isSearchOpen}
        items={items}
        logoLink={logoLink}
        logoLinkDescription={logoLinkDescription}
        logoType={logoType}
        metaMenu={metaMenu}
        rootLevel={rootLevel}
        setIsSearchOpen={setIsSearchOpen}
        setShowOverlay={setShowOverlay}
        showOverlay={showOverlay}
      />
    </>
  );
};

export default MobileNavigation;
